//M10-12866
import { Button } from "src/components";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

const OrderPOConfirmation = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const { orderDetails,stockistName } = location.state || {};
    const { selectedCounterData } = useSelector((state: RootState) => state.ordPoState);

    const totalPrice = Number(orderDetails[0]?.Order_Price);

    // const totalItems = Object.values(orderDetails[0]?.Product)?.reduce((acc: number, item: any) => acc + item?.quantity, 0);

    useEffect(() => {
        window.sessionStorage.removeItem("doctor_counter_id");
        if (!orderDetails || orderDetails?.length === 0) {
            navigate("/request-approval/orders");
        }
    }, []);

    return orderDetails ? (
        <div className="max-w-[1400px] mx-auto p-6 px-20 bg-white rounded-lg mt-10">
            {/* Header */}
            <div className="text-center mb-8">
                <div className="text-4xl text-green-500 mb-2">✔</div>
                <h2 className="text-3xl font-semibold">Thank you for placing an order</h2>
                <p className="text-[#4A4A4A] mt-2 text-sm">
                    Order initiated successfully on behalf of {selectedCounterData?.counter_location?.counter_hdr_id?.counter_name}
                </p>
                <div className="bg-[#F1F1F1] text-[#4A4A4A] inline-block px-4 py-1 rounded-md mt-4 text-sm font-medium">
                    {orderDetails.map((item: any) => item?.Order_OrderNumber).join(", ")}
                </div>
            </div>
            <div className="flex w-full gap-6 mb-8 mt-16">
                {/* Details Container */}
                <div className="flex flex-col w-[55%] gap-6 mb-8">
                    {/* Personnel Details */}
                    <div className="border border-[#D0D0D0] shadow-sm p-6 rounded-xl">
                        <h3 className="text-lg font-semibold pb-2 mb-4">Personal Details</h3>
                        <div className="space-y-3 text-[1rem]">
                            <p className="flex justify-between">
                                <p className="text-[#616161]">Stockist Name:</p> {stockistName}
                            </p>
                            <p className="flex justify-between">
                                <span className="text-[#616161]">Order No.:</span>
                                <span className="text-right">{orderDetails.map((item: any) => item?.Order_OrderNumber).join(", ")}</span>
                            </p>
                            <p className="flex justify-between">
                                <p className="text-[#616161]">Date: </p> {moment(orderDetails[0]?.Order_OrderDate).format("MMM Do, YYYY")}
                            </p>
                            <p className="flex justify-between">
                                <p className="text-[#616161]">Time: </p>
                                {moment(orderDetails[0]?.Order_OrderDate).format("h:mm A")}{" "}
                            </p>
                        </div>
                    </div>

                    {/* Order Details */}
                    <div className="bg-white border border-[#D0D0D0] p-4 rounded-xl">
                        <div className="flex justify-between items-center pb-2">
                            <h3 className="text-lg font-semibold mb-4 ">Order Details</h3>
                            <p className="border border-[#c4afff] rounded-lg text-[#8051ff] text-sm font-medium px-4 py-2">
                                {Object.keys(orderDetails[0]?.Product)?.length} Items
                            </p>
                        </div>{" "}
                        <div className="space-y-2 text-sm">
                            <table className="w-full border-separate border-spacing-y-3">
                                <tr className="text-[1rem]">
                                    <td className="text-[#616161]">Product Name</td>
                                    <td className="text-[#616161]">Qty.</td>
                                    <td className="text-[#616161]">Price</td>
                                </tr>
                                {orderDetails[0]?.Product &&
                                    Object.entries(orderDetails[0]?.Product)?.map(([_, item]: [string, any]) => (
                                        <tr className="text-[1rem]">
                                            <td>{item?.product_name}</td>
                                            <td>{item?.quantity}</td>
                                            <td>{item?.ptr}</td>
                                        </tr>
                                    ))}
                            </table>
                        </div>
                    </div>
                </div>

                {/* Order Summary */}
                <div className="bg-white w-[40%] px-10 rounded-lg text-[1rem]">
                    <div className="text-sm space-y-4">
                        <div className="flex justify-between">
                            
                        </div>
                    
                        <div className="flex justify-between text-lg font-bold mt-2">
                            <span className="text-[#616161] text-[1rem]">Total:</span>
                            <span className="text-[1rem]">₹{totalPrice?.toFixed(2)}</span>
                        </div>
                        <Button className="bg-[#8051FF] text-white w-full" onClick={() => navigate(`/transactions/orders/${2}`)}>
                            Back to orders
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="flex justify-center items-center h-screen">No data found</div>
    );
};

export default OrderPOConfirmation;
//M10-12866